enum PciDashboardStatusEnum {
  Unknown = "Unknown",
  PublishTableCreationStarted = "PublishTableCreationStarted",
  PublishTableCreationFinished = "PublishTableCreationFinished",
  PublishTableCreationFailed = "PublishTableCreationFailed",
  PublishTableCreationCanceled = "PublishTableCreationCanceled",
  IndexCreationStarted = "IndexCreationStarted",
  IndexCreationFinished = "IndexCreationFinished",
  IndexCreationFailed = "IndexCreationFailed",
  IndexCreationCanceled = "IndexCreationCanceled",
  PublishJobQueued = "PublishJobQueued",
  PublishJobStarted = "PublishJobStarted",
  PublishJobFinished = "PublishJobFinished",
  PublishJobSkipped = "PublishJobSkipped",
}

export { PciDashboardStatusEnum };